import React, { useState, useEffect, useRef, Fragment } from "react";
import Modal from "react-bootstrap/Modal";
import { useReactToPrint } from "react-to-print";
import Tooltip from "@mui/material/Tooltip";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, Link, useParams, useLocation } from "react-router-dom";
import { getPurchaseDetails, getAllRecords, logPurchaseOrderHistory, getWarehouseKeyValueList } from "../../../services/index";
import ViewPdf from "../../Common/ViewPdf";
import AddIcon from "@mui/icons-material/Add";
import ReceiptIcon from "@mui/icons-material/Receipt";
import EditIcon from "@mui/icons-material/Edit";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { searchForMatch } from "../../utils/textUtils"
import Select from "react-select";
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';

const PurchaseView = (props) => {
    let { id } = useParams();
    const { state } = useLocation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [keys, setKeys] = useState("");
    const [values, setValues] = useState("");
    const [tabIndex, setTabIndex] = useState(0);
    const [hsnKey, setHsnKey] = useState("");
    const [hsnVal1, setHsnVal1] = useState("");
    const [hsnVal2, setHsnVal2] = useState("");
    const [taxType, setTaxType] = useState("");
    const [orgDetail, setOrgDetail] = useState("");
    // const [orgDetails2, setorgDetails2] = useState("");
    const [logData, setLogData] = useState({});
    const [purchaseOrdersList, setPurchaseOrdersList] = useState([]);
    const [purchaseOrderDetail, setPurchaseOrderDetail] = useState(null);
    const [index, setIndex] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [purchaseOrdersListDetails, setPurchaseOrdersListDetails] = useState(null);
    const [selectedWarehouse, setSelectedWarehouse] = useState({
        label: "",
        value: ""
    });
    const [wareOptions, setWareOptions] = useState(null);
    let navigate = useNavigate();

    const [rows, setRows] = useState([]);
    const getAllPurchaseOrders = () => {
        let list_data = {
            page: index,
            size: 15,
            search: filterText,
            uuid2: selectedWarehouse.value
        };
        getAllRecords(list_data).then((res) => {
            if (res.errorCode === 0) {
                // setorgDetails2(res?.responsePacket?.organisationDetail?.beanAddress?.state)
                if (index === 0) {
                    setPurchaseOrdersList(res.responsePacket.data);
                    setRows(res.responsePacket.data);
                } else {
                    const purchaseOrdersListClone = [...purchaseOrdersList, ...res.responsePacket.data];
                    setPurchaseOrdersList(purchaseOrdersListClone);
                    setRows(purchaseOrdersListClone);
                }
                setIndex(index + 1);
                setPurchaseOrdersListDetails({
                    recordsFiltered: res.responsePacket.recordsFiltered,
                    recordsTotal: res.responsePacket.recordsTotal,
                    total: res.responsePacket.total,
                });
                // res.responsePacket.data.reverse();
            } else {
                toast(res.message);
            }
        });
    };

    const getWarehouseOptions = () => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                if (state?.warehouse) {
                    setSelectedWarehouse(state.warehouse)
                }
                else {
                    setSelectedWarehouse(options[0])
                }
                setWareOptions(options);
            }
        });
    }

    useEffect(() => {
        if (selectedWarehouse.value !== "") {
            getAllPurchaseOrders();
        }
    }, [filterText, selectedWarehouse])

    const getPurchase = (id) => {
        getPurchaseDetails(id).then((res) => {
            if (res.errorCode === 0) {
                let resDetails = res.responsePacket;
                let resItems = res.responsePacket.items;

                resDetails.address?.map((address) => {
                    if (address.addressType === "Billing") {
                        resDetails.billAdd = address;
                    }

                    if (address.addressType === "Shipping") {
                        resDetails.shipAdd = address;
                    }
                });

                let netTax = 0;
                let disTax = 0;
                let disPercent = 0;
                let disAmount = 0;
                let disSubtotal = 0;

                let sub1 = 0;
                resItems?.map((item) => {
                    sub1 = sub1 + item.amount;
                });
                if (Number(sub1).toFixed(2) !== Number(resDetails.subTotalAmount).toFixed(2)) {
                    toast.error("subtotal mismatch");
                }

                var subtot = JSON.parse(JSON.stringify(res.responsePacket.subTotalAmount));

                if (resDetails.discountTypeEnum === "Percentage") {
                    let dis = 0.01 * resDetails.discountValue * subtot;
                    disPercent = resDetails.discountPercent = resDetails.discountValue;
                    disAmount = resDetails.discountAmount = dis;
                    resDetails.discountSubTotal = subtot - resDetails.discountAmount;
                } else if (resDetails.discountTypeEnum === "Amount") {
                    let dis = (100 * resDetails.discountValue) / subtot;
                    disPercent = resDetails.discountPercent = dis;
                    disAmount = resDetails.discountAmount = resDetails.discountValue;
                    resDetails.discountSubTotal = subtot - resDetails.discountAmount;
                } else {
                    resDetails.discountSubTotal = subtot;
                    resDetails.discountPercent = 0;
                    resDetails.discountAmount = 0;
                }

                resItems?.map((item) => {
                    item.taxBean = item.taxes;
                    item.taxBean.newTax = item.taxBean?.taxType + item.taxBean?.rate?.toString();
                    item.taxBean.disAmount = item.taxBean?.amount;
                    item.disItemAmount = item.amount;
                    netTax += item.taxBean.amount;
                    disTax += item.taxBean.disAmount;
                    disSubtotal += item.taxBean.disItemAmount;
                });

                let obj = {};
                for (let i = 0; i < resItems.length; i++) {
                    if (obj[resItems[i].taxBean.newTax]) {
                        obj[resItems[i].taxBean.newTax] += resItems[i].taxBean.disAmount;
                    } else {
                        obj[resItems[i].taxBean.newTax] = resItems[i].taxBean.disAmount;
                    }
                }
                let s1 = resDetails?.shippingChargeTaxTitle?.split(" ")[0];
                let s2 = resDetails?.shippingChargeTaxTitle?.split(" ")[1];

                let shipTaxTitle = (resDetails.shippingChargeTaxTitle2 = s1 + s2);

                setKeys(Object.keys(obj));
                setValues(Object.values(obj));
                let arr = [];
                Object.keys(obj)?.map((a, i) => {
                    Object.values(obj)?.map((b, j) => {
                        if (i === j) {
                            return arr.push({ tax: a, value: b });
                        }
                    });
                });

                let z = JSON.parse(JSON.stringify(resItems));

                z?.map((a) => {
                    a.newHsn = a.hsnSac.toString() + "_" + a.taxBean.newTax;
                });

                let obj2 = {};
                for (let i = 0; i < z.length; i++) {
                    if (obj2[z[i].newHsn]) {
                        obj2[z[i].newHsn] += z[i].taxBean.disAmount;
                    } else {
                        obj2[z[i].newHsn] = z[i].taxBean.disAmount;
                    }
                }

                let obj3 = {};
                for (let i = 0; i < z.length; i++) {
                    if (obj3[z[i].newHsn]) {
                        obj3[z[i].newHsn] += z[i].disItemAmount;
                    } else {
                        obj3[z[i].newHsn] = z[i].disItemAmount;
                    }
                }

                setHsnKey(Object.keys(obj2));
                setHsnVal1(Object.values(obj2));
                setHsnVal2(Object.values(obj3));

                let t2 = resDetails.totalAmount.toFixed(2).toString()?.split(".")[1];
                if (t2 > 49) {
                    resDetails.totalAmount += 1;
                    let a = 100 - t2;
                    resDetails.rounding = "+0." + a;
                } else {
                    resDetails.rounding = "-0." + t2;
                }

                resDetails.netTax = netTax;
                resDetails.disTax = disTax;
                resDetails.shipValue = resDetails.shippingCharges / (1 + resDetails.shippingChargeTaxRate * 0.01);
                let zx = (resDetails.shipTaxValue = resDetails.shippingCharges - resDetails.shipValue);

                arr?.map((a) => {
                    if (a.tax === shipTaxTitle) {
                        a.value = a.value + zx;
                    }
                });

                resDetails.taxDetail = arr;
                logPurchaseOrderHistory(res.responsePacket.purchaseOrderNo).then((res) => {
                    if (res.errorCode === 0) {
                        const resItems = res.responsePacket;
                        setLogData(resItems);
                    } else {
                        toast(res.message);
                    }
                });

                let localDate = new Date(resDetails.purchaseOrderDate).toISOString().replace(/T.*/, "")?.split("-").reverse().join("-");

                resDetails.purchaseOrderDate = localDate;
                setPurchaseOrderDetail(resDetails);
                let org = JSON.parse(localStorage.getItem("orgDetail"));
                setOrgDetail(org);

                if (org?.beanAddress?.state === undefined) {
                    alert("logged In user's organization address not found ");
                }

                // let customerAddress;
                // res.responsePacket.address.map((item) => {
                //     if (item.addressType === "Billing") {
                //         customerAddress = item.state;
                //     }
                // })

                let gst12cust = res.responsePacket.vendorGst.substring(0, 2);
                let gst12org = res.responsePacket?.warehouseDetails?.gstNumber.substring(0, 2);
                if (gst12cust === gst12org) {
                    setTaxType("intra");
                } else {
                    // if (customerAddress === orgDetails2) {
                    //     setTaxType("intra");
                    // }else{
                    setTaxType("inter");
                    // }
                }
            } else {
                toast(res.message);
            }
        });
    };

    useEffect(() => {
        getWarehouseOptions();
    }, [])

    useEffect(() => {
        getPurchase(id);
    }, [id]);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    let time;
    const handleSearch = (e) => {
        const { value } = e.target;
        clearTimeout(time);
        time = setTimeout(() => {
            setIndex(0);
            setFilterText(value);
        }, 500);
    };

    const filterOptions = [
        { value: "isBilled", label: "isBilled" },
        { value: "isPaid", label: "isPaid" },
        { value: "isPacked", label: "isPacked" },
        { value: "allOrders", label: "allOrders" },
    ];

    const handleFilter = (e) => {
        // if (e.value === "isPaid") {
        //     var arr1 = rows.filter((data) => data.isPaid);
        //     setPurchaseOrdersList(arr1);
        // }
        // if (e.value === "isBilled") {
        //     var arr2 = rows.filter((data) => data.isBilled);
        //     setPurchaseOrdersList(arr2);
        // }
        // if (e.value === "isPacked") {
        //     var arr3 = rows.filter((data) => data.isPacked);
        //     setPurchaseOrdersList(arr3);
        // }
        // if (e.value === "allOrders") {
        //     var arr3 = rows.filter((data) => data.orderNo);
        //     setPurchaseOrdersList(arr3);
        // }
        setIndex(0);
        setSelectedWarehouse(e);
    };

    return (
        <>
            <div className="list-column column d-print-none" style={{ width: "300px" }}>
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <div className="listFilterAndSearch">
                            <Link to="/purchase/new" className="newListBtn">
                                <AddIcon />
                            </Link>
                            <div className="listFilter">
                                <Select value={selectedWarehouse} options={wareOptions} onChange={handleFilter} />
                            </div>
                            <div className="input-group paginationSearchInput listSearch">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text" id="basic-addon1">
                                        <SearchRoundedIcon />
                                    </span>
                                </div>
                                <input autoComplete="off" className="form-control" type="text" placeholder="Search..." onChange={handleSearch} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="scroll-y fill body scrollbox list-body">
                    <div className="table-responsive overflow-initial ">
                        <table id="ember7912" className="table zi-table table-hover ember-view header-fixed">
                            {purchaseOrdersList && purchaseOrdersList.length > 0 ?
                                <tbody>
                                    {purchaseOrdersList?.map((d, i) => (
                                        <tr key={i} className={`listTr ${id === d.recordId ? "activeRecord" : ""}`}>
                                            <td>
                                                <Link to={`/purchase/${d.recordId}`} className={`${id === d.recordId ? "text-primary" : "text-grey"}`}>
                                                    <span className="titleTr">{d.vendorTitle}</span>
                                                    <span className="d-flex justify-content-between">
                                                        <span>{d.purchaseOrderNo}</span>
                                                        <span>₹{d.totalAmount.toFixed(2)}</span>
                                                    </span>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                    {
                                        purchaseOrdersListDetails &&
                                        purchaseOrdersListDetails?.recordsTotal > purchaseOrdersList.length && (
                                            <div className="pt-3">
                                                <button
                                                    className="btn mx-auto newListBtn"
                                                    onClick={getAllPurchaseOrders}
                                                >
                                                    Load More
                                                </button>
                                            </div>

                                        )
                                    }
                                </tbody> : (
                                    <div className="my-3 text-black text-center">
                                        No Data Available!
                                    </div>
                                )
                            }
                        </table>
                    </div>
                </div>
            </div>
            <div className="column content-column" style={{ left: "301px" }}>
                <div className="fill1 header d-flex align-items-center p-4 justify-content-between">
                    <div className="btn-toolbar over-flow text-muted font-xlarge">
                    </div>
                    <div className="btn-toolbar d-flex justify-content-end align-items-center">
                        <div>
                            <button className="tooltip-container ember-view btn btn-primary print-btn" onClick={handlePrint}>
                                <LocalPrintshopOutlinedIcon />
                            </button>
                        </div>
                        {purchaseOrderDetail?.isBilled ? (
                            <></>
                        ) : (
                            <>
                                {purchaseOrderDetail?.isConfirm ? <></> : <button className="tooltip-container ember-view btn btn-primary " onClick={() => navigate("/purchase/" + purchaseOrderDetail.recordId + "/edit")}>
                                    <EditIcon />
                                </button>}
                                <button
                                    className="tooltip-container ember-view btn btn-primary"
                                    onClick={() => navigate(`/convertbill/${purchaseOrderDetail.recordId}`, { state: "bill" })}
                                    type="button"
                                >
                                    <Tooltip title="Create Bill">
                                        <ReceiptIcon />
                                    </Tooltip>
                                </button>
                            </>
                        )}
                    </div>
                </div>
                <br />
                <div>
                    <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)} className="upperTabs">
                        <TabList>
                            <Tab>Primary Details</Tab>
                            <Tab>Log History</Tab>
                        </TabList>
                        <TabPanel>
                            {purchaseOrderDetail && purchaseOrderDetail && orgDetail && orgDetail ? (
                                <ViewPdf
                                    orderDetail={purchaseOrderDetail}
                                    itemList={purchaseOrderDetail.items}
                                    address={purchaseOrderDetail.address}
                                    orgDetail={orgDetail}
                                    taxType={taxType}
                                    componentRef={componentRef}
                                    pdfType={"purchase"}
                                    keys={keys}
                                    values={values}
                                    handlePrint={handlePrint}
                                    hsnKey={hsnKey}
                                    hsnVal1={hsnVal1}
                                    hsnVal2={hsnVal2}
                                />
                            ) : (
                                <></>
                            )}
                        </TabPanel>
                        <TabPanel>
                            <div className="ember-view scroll-y noscroll-x fill body scrollbox">
                                <table>
                                    <tbody>
                                        {logData.length === 0 ? (
                                            "No Changes Found"
                                        ) : (
                                            <tr>
                                                <td>Date</td>
                                                <td>Changes</td>
                                            </tr>
                                        )}
                                        {logData.length >= 1 &&
                                            logData?.map((history, i) => {
                                                return (
                                                    <Fragment key={i}>
                                                        <tr>
                                                            <td style={{ verticalAlign: "top", width: "80px" }}>
                                                                {history?.transactionDate?.substring(0, 10)}
                                                                :&nbsp;&nbsp;
                                                            </td>

                                                            <td>
                                                                <div dangerouslySetInnerHTML={{ __html: history?.message.replaceAll("\n", "<br />").replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;") }} />
                                                                {/* {history?.message?.split("\n")?.map((b, j) => (
                                                        <tr key={j}>
                                                            {b.includes("\t") ? <div style={{ marginLeft: "20px" }}>{b}</div> : b.includes("\t\t") ? <div style={{ marginLeft: "40px" }}>{b}</div> : b}
                                                        </tr>
                                                    ))} */}
                                                            </td>
                                                        </tr>
                                                        <hr />
                                                    </Fragment>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </TabPanel>
                    </Tabs>
                </div>

            </div>
            <Toaster />
        </>
    );
};

export default PurchaseView;
